"use client";

import { Badge } from "@/shared/components/common/Badge";
import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/components/common/Tooltip";
import Typography from "@/shared/components/common/Typography";
import { facilityIcons } from "@/shared/constants/icons";
import type { Facility } from "@/types/services/hotel/apis/Detail";

interface FacilitiesProps {
  facilities: Facility[];
}

export default function Facilities({ facilities }: FacilitiesProps) {
  return (
    <Flex
      direction={"col"}
      className="bg-background gap-10 md:shadow-1 md:ring-1 ring-ring rounded md:rounded-md max-sm:border p-4"
    >
      <List
        items={groupFacilities(facilities)}
        renderItems={({ title, facility }) => (
          <Flex direction={"col"} className="gap-y-4">
            <Typography variant="h3" className="font-medium">
              {title}
            </Typography>
            <Flex className="gap-3 flex-wrap px-2">
              {facility.map(({ title, description, icon }) => (
                <TooltipProvider key={icon}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Badge className="cursor-pointer rounded-full bg-muted dark:bg-muted/10 shadow-none text-muted-foreground! dark:!text-foreground p-2">
                        <Flex className="items-center gap-x-2">
                          <Typography className="text-xs text-muted-foreground">
                            {title}
                          </Typography>

                          {facilityIcons[icon]}
                        </Flex>
                      </Badge>
                    </TooltipTrigger>
                    <TooltipContent>
                      <Typography variant="body2">{description}</Typography>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ))}
            </Flex>
          </Flex>
        )}
      />
    </Flex>
  );
}

export function groupFacilities(facilities: Facility[]) {
  const groupedArr: {
    title: string;
    facility: Facility[];
    id: string;
  }[] = [];
  for (let x = 0; x < facilities.length; ++x) {
    const sample = facilities[x].group_title;

    const filtered = facilities.filter((item) => item.group_title === sample);

    if (
      !groupedArr.some((arr) =>
        arr.facility.find((item) => item.group_title === sample),
      )
    ) {
      groupedArr.push({
        title: filtered[0].group_title,
        facility: filtered,
        id: `facility-${facilities[x].id}`,
      });
    }
  }
  return groupedArr;
}
